var _rect, _rect2, _path, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInternationalPassport = function SvgInternationalPassport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 64,
    viewBox: "0 0 46 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6.01025,
    width: 36.201,
    height: 56,
    rx: 4,
    transform: "rotate(-7.9557 1 6.01025)",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6.01074,
    width: 44,
    height: 56,
    rx: 4,
    fill: "",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8756 31.4191C18.8756 31.4191 17.146 30.5496 15.9735 29.9612C15.7289 29.8379 15.5586 29.6049 15.5147 29.3352C15.4719 29.0656 15.5607 28.7908 15.754 28.5974C15.915 28.4355 16.0728 28.2787 16.1982 28.1533C16.3643 27.9871 16.5922 27.8962 16.8273 27.9035L19.8235 27.9976L21.2688 26.5523L15.6892 23.1527C15.4687 23.0179 15.3214 22.789 15.29 22.5309C15.2597 22.2738 15.3485 22.0167 15.5314 21.8328C15.6735 21.6917 15.8136 21.5517 15.9327 21.4326C16.1344 21.2309 16.4239 21.1441 16.704 21.2026L24.4917 23.3293L27.2987 20.5223C27.9811 19.8399 29.0899 19.8399 29.7724 20.5223C30.4548 21.2047 30.4548 22.3135 29.7724 22.996L26.9654 25.803L29.092 33.5907C29.1506 33.8708 29.0638 34.1603 28.8621 34.362C28.743 34.4811 28.6029 34.6211 28.4619 34.7633C28.2779 34.9461 28.0209 35.035 27.7638 35.0047C27.5056 34.9733 27.2768 34.826 27.142 34.6055L23.7424 29.0259L22.2981 30.4702L22.3964 33.4611C22.4037 33.6963 22.3138 33.9251 22.1477 34.0913C22.0212 34.2177 21.8613 34.3776 21.6972 34.5407C21.5039 34.734 21.2291 34.8228 20.9594 34.78C20.6898 34.7361 20.4568 34.5657 20.3334 34.3212L18.8756 31.4191Z",
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2842,
    y: 49.0559,
    width: 14.25,
    height: 2.59091,
    rx: 1.29545,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2842,
    y: 43.874,
    width: 19.4318,
    height: 2.59091,
    rx: 1.29545,
    fill: "currentColor"
  })));
};
export { SvgInternationalPassport as ReactComponent };